import { useTranslation } from "react-i18next";

export function useAppTranslation(ns?: string | string[]) {
  return useTranslation(ns);
}
